<template>
  <div class="text-right publish-sign">
    <div class="upload-file">
      <template v-if="this.$store.getters.authUser.identityAuth > -1">
        <el-button :size="size" type="danger">{{ fileText }}</el-button>
        <input @change="handleInputChange($event)" type="file" />
      </template>
      <template v-else>
        <el-button :size="size" type="danger" @click="authDialog = true">{{
          fileText
        }}</el-button>
      </template>
    </div>
    <el-button @click="toTpl" type="success" :size="size" class="tpl">{{
      tplText
    }}</el-button>

    <el-dialog :visible.sync="authDialog" title="实名认证" width="475px">
      <p class="authDialog">
        <img
          src="../../static/images/warning.png"
        />您还未完成实名认证，认证后才能执行该操作。
      </p>
      <template slot="footer">
        <el-button
          style="border: none; background: #ec1c1c; color: #ffffff"
          size="small"
          @click="gotoAuth"
          >去认证</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFileAndConvertInfo } from '../../assets/js/http-serve/http-methods';
import Vue from 'vue';
import { isInDingTalk } from '@/assets/js/utils/ding-env';

function getStore () {
  return Vue.prototype.$storeInstance;
}
export default {
  data () {
    return {
      loading: null,
      authDialog: false,
    }
  },
  methods: {
    gotoAuth () {
      if (+getStore().getters.authUser.userType === 0) {
        getStore().$router.push('/auth/personalIdentityAuth');
      } else {
        getStore().$router.push('/auth/authGuide');
      }
    },
    // input内容change事件处理
    handleInputChange: function (e) {
      let file = e.target.files[0] || e.value;
      let filename = file.name.split('.')[0];
      let reg = new RegExp('(.jpg|.png|.bmp|.jpeg|.pdf|.doc|.docx|.xls|.xlsx|.wps)$', 'i');

      if (!reg.test(file.name)) {
        e.target.value = '';
        return this.$message.warning('文件格式只能是jpg/png/bmp/pdf/doc/docx/xls/xlsx/wps的文件');
      }

      if (file.size > 1024 * 1024 * 20) {
        e.target.value = '';
        return this.$message.warning('文件大小不能超过20M');
      }

      this.uploadTempFile(file, filename);
      e.target.value = '';
    },
    // 上传临时合同文件
    uploadTempFile (file, fileName) {
      this.loadingStart();
      uploadFileAndConvertInfo({ file: file, fileType: 1, fileName: fileName })
        .then((data) => {
          this.loadingClose();
          this.toCreate(data);
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || '上传合同失败');
        });
    },
    // 前往完善签署信息
    toCreate ({ targetId, sign, ts, fileName, items, docHash }) {
      this.$confirm('文件上传成功，立即前往编辑签署人信息？', '温馨提示', {
        showCancelButton: false,
        showConfirmButton: true,
        type: 'info'
      })
        .then(() => {
          let { href } = this.$router.resolve({ path: '/applySign/toCreate', query: { contractId: targetId, sign: sign, ts: ts, contractName: fileName, items: items, docHash: docHash } })
          isInDingTalk ? location.href = href : window.open(href, '_blank')
        });
    },
    // 前往模板列表发起模板签署
    toTpl: function () {
      let { href } = this.$router.resolve({ path: '/tpl/general' });
      isInDingTalk ? location.href = href : window.open(href, '_blank');
    },
    loadingStart (info) {
      this.loadingClose();
      this.loading = this.$loading({
        lock: true,
        text: info || '正在上传合同',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, .5)'
      })
    },
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    }
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    fileText: {
      type: String,
      default: '文件发起签署'
    },
    tplText: {
      type: String,
      default: '模板发起签署'
    }
  },
  name: "publish-sign"
}
</script>

<style lang="less" scoped>
.tpl {
  margin-bottom: 10px;
  vertical-align: top;
  background: #290202;
  border-color: #290202;
}
.upload-file {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 20px;
  overflow: hidden;

  input[type="file"] {
    position: absolute;
    left: -68px;
    top: 0;
    width: 200px;
    height: 200px;
    opacity: 0;
    cursor: pointer;
  }

  &:hover .el-button {
    opacity: 0.7;
  }
}
.tpl.el-button:hover {
  opacity: 0.75;
  background: #290202 !important;
  border-color: #290202 !important;
}
.tpl.el-button.active,
.tpl.el-button:focus {
  background: #290202 !important;
  border-color: #290202 !important;
}
.authDialog {
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-left: 40px;
  margin-bottom: 60px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 2, 2, 0.65);

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
/deep/ .el-button--small:hover {
  opacity: 0.7 !important;
}
</style>



// WEBPACK FOOTER //
// components/publish-sign/index.vue